import React, { useCallback, useMemo, useState } from 'react';
import { Tab, Tabs } from '@cubeyou-team/hx-react-components';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import ConversationExplorer from '../../components/ConversationExplorer';
import { ConversationAdvancedOptions } from '../../components/QueryBuilder/components';
import { changeAudienceTimeframeRequest } from '../../actions';

const StyledConversationExplorerContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;

  & [data-test='children-container'] {
    flex: 1 1 auto;
    min-height: 0;
    padding-top: 0px;
  }

  & .tab-item {
    height: 100%;
  }
`;

const ConversationExplorerContainer = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const dispatch = useDispatch();
  const queryBuilder = useSelector(state => state.queryBuilder);
  const conversation = useSelector(state => state.conversation);
  const selectedTarget = useSelector(
    state => state.queryBuilder.target_selected
  );

  const queryPreview = useMemo(() => {
    const preview = {
      ...queryBuilder.targets[selectedTarget],
    };
    return preview;
  }, [queryBuilder, selectedTarget]);

  const handleAudienceTimeframeChangeRequest = useCallback(
    audience_timeframe => {
      dispatch(
        changeAudienceTimeframeRequest(audience_timeframe, selectedTarget)
      );
    },
    [dispatch, selectedTarget]
  );

  return (
    <StyledConversationExplorerContainer>
      <Tabs
        data-test-id="tabs"
        onTabChange={tab => {
          setSelectedTab(tab);
        }}
        selectedTab={selectedTab}
      >
        <Tab title="Recent">
          <ConversationExplorer />
        </Tab>
        <Tab title="Advanced options">
          <ConversationAdvancedOptions
            query={queryPreview}
            mentions={conversation.mentions}
            onAudienceTimeframeChange={handleAudienceTimeframeChangeRequest}
          />
        </Tab>
      </Tabs>
    </StyledConversationExplorerContainer>
  );
};

export default ConversationExplorerContainer;
